export default __webpack_public_path__ + "static/media/119.461dbd8f.png";